export function isBackofficeRole(role) {
  return ['superadmin', 'admin', 'manager', 'operator', 'merchant', 'auditor', 'compliance_officer'].includes(role);
}

export function defaultRouteForRole(role) {
  if (role === 'member') return '/member';
  if (role === 'superadmin') return '/tenants';
  if (role === 'merchant') return '/payments';
  if (isBackofficeRole(role)) return '/payments';
  return '/dashboard';
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch {
    return null;
  }
}

export function getStoredRole() {
  return getStoredUser()?.role || null;
}

export function getTopNavLinks(role) {
  if (role === 'member') {
    return [{ to: '/member', label: 'Portal' }];
  }

  if (isBackofficeRole(role)) {
    const matrix = {
      superadmin: [
        { to: '/tenants', label: 'Tenants' },
        { to: '/plans', label: 'Planes' },
        { to: '/dashboard', label: 'Dashboard' },
        { to: '/payments', label: 'Pagos' },
        { to: '/members', label: 'Miembros' },
        { to: '/accounts', label: 'Cuentas' },
        { to: '/transactions', label: 'Transacciones' },
        { to: '/reconciliation', label: 'Conciliación' },
        { to: '/merchants', label: 'Comercios' },
        { to: '/settings', label: 'Configuración' },
      ],
      admin: [
        { to: '/dashboard', label: 'Dashboard' },
        { to: '/payments', label: 'Pagos' },
        { to: '/members', label: 'Miembros' },
        { to: '/accounts', label: 'Cuentas' },
        { to: '/transactions', label: 'Transacciones' },
        { to: '/reconciliation', label: 'Conciliación' },
        { to: '/merchants', label: 'Comercios' },
        { to: '/settings', label: 'Configuración' },
      ],
      manager: [
        { to: '/dashboard', label: 'Dashboard' },
        { to: '/payments', label: 'Pagos' },
        { to: '/members', label: 'Miembros' },
        { to: '/accounts', label: 'Cuentas' },
        { to: '/transactions', label: 'Transacciones' },
      ],
      operator: [
        { to: '/dashboard', label: 'Dashboard' },
        { to: '/payments', label: 'Pagos' },
        { to: '/members', label: 'Miembros' },
        { to: '/accounts', label: 'Cuentas' },
        { to: '/transactions', label: 'Transacciones' },
      ],
      merchant: [
        { to: '/payments', label: 'Pagos' },
      ],
      auditor: [
        { to: '/dashboard', label: 'Dashboard' },
        { to: '/payments', label: 'Pagos' },
        { to: '/members', label: 'Miembros' },
        { to: '/accounts', label: 'Cuentas' },
        { to: '/transactions', label: 'Transacciones' },
        { to: '/reconciliation', label: 'Conciliación' },
        { to: '/merchants', label: 'Comercios' },
      ],
      compliance_officer: [
        { to: '/dashboard', label: 'Dashboard' },
        { to: '/payments', label: 'Pagos' },
        { to: '/members', label: 'Miembros' },
        { to: '/accounts', label: 'Cuentas' },
        { to: '/transactions', label: 'Transacciones' },
        { to: '/reconciliation', label: 'Conciliación' },
        { to: '/merchants', label: 'Comercios' },
      ],
    };

    return matrix[role] || [{ to: '/dashboard', label: 'Dashboard' }];
  }

  return [{ to: '/dashboard', label: 'Dashboard' }];
}
